<template>
  <section class="cta-section">
    <v-container>
      <div class="cta-content animate-block">
        <!-- CTA Text with inline arrow -->
        <h2 class="cta-text">
          <span class="arrow-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V22C0 22.5304 0.210714 23.0391 0.585786 23.4142C0.960859 23.7893 1.46957 24 2 24H22C22.5304 24 23.0391 23.7893 23.4142 23.4142C23.7893 23.0391 24 22.5304 24 22V2C24 1.46957 23.7893 0.960859 23.4142 0.585786C23.0391 0.210714 22.5304 0 22 0ZM17.7075 12.7075L13.7075 16.7075C13.5199 16.8951 13.2654 17.0006 13 17.0006C12.7346 17.0006 12.4801 16.8951 12.2925 16.7075C12.1049 16.5199 11.9994 16.2654 11.9994 16C11.9994 15.7346 12.1049 15.4801 12.2925 15.2925L14.5863 13H7C6.73478 13 6.48043 12.8946 6.29289 12.7071C6.10536 12.5196 6 12.2652 6 12C6 11.7348 6.10536 11.4804 6.29289 11.2929C6.48043 11.1054 6.73478 11 7 11H14.5863L12.2925 8.7075C12.1049 8.51986 11.9994 8.26536 11.9994 8C11.9994 7.73464 12.1049 7.48014 12.2925 7.2925C12.4801 7.10486 12.7346 6.99944 13 6.99944C13.2654 6.99944 13.5199 7.10486 13.7075 7.2925L17.7075 11.2925C17.8005 11.3854 17.8742 11.4957 17.9246 11.6171C17.9749 11.7385 18.0008 11.8686 18.0008 12C18.0008 12.1314 17.9749 12.2615 17.9246 12.3829C17.8742 12.5043 17.8005 12.6146 17.7075 12.7075Z" fill="#1CA5BE"/>
            </svg>
          </span>
          {{ $t('cta.heading') }}
        </h2>

        <!-- Buttons -->
        <div class="cta-buttons">
          <v-btn
            variant="flat"
            class="plus-btn"
            icon
            @click="openContact"
          >
            <v-icon color="white">mdi-plus</v-icon>
          </v-btn>

          <v-btn
            variant="flat"
            class="contact-btn"
            @click="openContact"
          >
            {{ $t('cta.btn') }}
          </v-btn>

        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
import { eventBus } from '@/eventBus'
import { animateOnScroll } from '@/mixins/animateOnScroll'

export default {
  name: 'CtaSection',
  mixins: [animateOnScroll],
  methods: {
    openContact() {
      eventBus.showContactModal = true
    }
  }
}
</script>

<style scoped>
.cta-section {
  padding: 80px 0;
  background-color: #ededed;
}

.cta-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}

.arrow-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  vertical-align: middle;
  margin-right: 8px;
}

.cta-text {
  font-family: "SF Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 40px;
  font-weight: 500;
  line-height: 48.8px;
  letter-spacing: -0.02em;
  color: rgb(46, 46, 46);
  margin: 0;
  max-width: 763px;
  text-indent: 50px;
}

.cta-buttons {
  display: flex;
  gap: 5px;
  align-items: center;
}

.plus-btn {
  width: 38px !important;
  height: 38px !important;
  min-width: 38px !important;
  background: #1CA5BE;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: none;
}

.contact-btn {
  height: 38px !important;
  padding: 0 10px;
  min-width: 154px;
  background: #1CA5BE;
  color: rgb(241, 241, 241);
  text-transform: none;
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.01em;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: none;
}

.plus-btn:hover,
.contact-btn:hover {
  background: rgb(24, 145, 168);
}

/* Responsive */
@media (max-width: 960px) {
  .cta-section {
    padding: 60px 0;
  }

  .cta-text {
    font-size: 32px;
  }

  .arrow-icon {
    width: 40px;
    height: 40px;
  }

  .arrow-icon .v-icon {
    font-size: 20px;
  }

  .plus-btn {
    width: 44px;
    height: 44px;
  }

  .contact-btn {
    height: 44px;
    font-size: 15px;
  }
}

@media (max-width: 600px) {
  .cta-section {
    padding: 40px 0;
  }

  .cta-content {
    gap: 24px;
  }

  .cta-text {
    font-size: 24px;
  }

  .arrow-icon {
    width: 36px;
    height: 36px;
  }

  .arrow-icon .v-icon {
    font-size: 18px;
  }

  .plus-btn {
    width: 40px;
    height: 40px;
  }

  .contact-btn {
    height: 40px;
    font-size: 14px;
    padding: 0 24px;
  }
}
</style>
